import React, { Component } from 'react';
import { connect } from 'dva';
import { Table } from 'antd';

@connect(({ contactsList }) => ({
  ...contactsList,
}))
class BaseCounty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
  }

  // 修改页面
  handleChangePagination = (page, callback) => {
    this.setState(
      {
        currentPage: page,
      },
      () => {
        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
          callback();
        }
      }
    );
  };

  render() {
    const { countTreeList, countHeaders } = this.props;
    const { currentPage } = this.state;

    const tableProps = {
      columns: countHeaders,
      dataSource: countTreeList,

      pagination: {
        pageSizeOptions: ['20', '50', '100', '200'],
        current: currentPage,
        defaultPageSize: 20,
        showSizeChanger: true,
        showQuickJumper: true,
        onChange: this.handleChangePagination,
        onShowSizeChange: () => this.handleChangePagination(1),
      },
    };

    if (countTreeList.length > 0) {
      tableProps.footer = () => (
        <div className="table-footer">{`共 ${countTreeList.length} 条记录 第 ${currentPage} 页`}</div>
      );
    }

    return <div className="address-container"><Table dataSource={countTreeList} columns={countHeaders}/></div>;
  }
}

export default BaseCounty;
